enum UploadStatus {
  Success,
  Failure,
  Uploading
}

export default UploadStatus;
